var React = require('react');

function MobilePhone (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"mobile-phone-2"),React.createElement("path",{"d":"M17,.034H7a3,3,0,0,0-3,3V20.966a3,3,0,0,0,3,3H17a3,3,0,0,0,3-3V3.034A3,3,0,0,0,17,.034ZM12,22.466a1,1,0,1,1,1-1A1,1,0,0,1,12,22.466Zm6-4.5a1,1,0,0,1-1,1H7a1,1,0,0,1-1-1V3.534a1,1,0,0,1,1-1H17a1,1,0,0,1,1,1Z","key":1})]);
}

MobilePhone.defaultProps = {"viewBox":"0 0 24 24"};

module.exports = MobilePhone;

MobilePhone.default = MobilePhone;
